export default ['name', 'address_one', 'address_two', 'town', 'county', 'postcode', 'country', 'latitude', 'longitude'].map((f) => {
	return {
		name: f,
		component: 'base-input'
	};
});
